// Unpublished Work © 2020 Deere & Company

import t from 'tcomb';

export const ValidationError = t.irreducible('ValidationError', (x) => x instanceof Set);
